import useWindowSize from '@shared/hooks/useWindowsSize';
import CoverageDetails from '../../CoverageDetails';
import SellerBlock from './SellerBlock';
import SubsidiaryDetails from '@shared/components/SubsidiarySelectorContent/SubsidiaryDetails';
import BoxContainer from '@shared/components/BoxContainer';
import PriceDetails from '../../PriceDetails';

const CoverageDescription = ({
  cardData,
  storagePassengers,
  subsidiary,
  seller,
}) => {
  const screenSize = useWindowSize();

  return (
    <BoxContainer>
      <CoverageDetails
        storagePassengers={storagePassengers}
        cardData={cardData}
      />

      <PriceDetails
        storagePassengers={storagePassengers}
        cardData={cardData}
        total={storagePassengers?.price?.details_USD?.total}
        isPayment={!cardData}
        hasCharges={!!storagePassengers?.price?.details?.charges}
      />

      {subsidiary?.name && (
        <SubsidiaryDetails
          id="subsidiary-details"
          subsidiary={subsidiary}
          withLogo={true}
          imageWidth={140}
        />
      )}
      {seller && <SellerBlock seller={seller} screenWidth={screenSize.width} />}
    </BoxContainer>
  );
};

export default CoverageDescription;
